import {
  Box,
  Button,
  FormControl,
  InputBase,
  Typography,
  useTheme
} from '@mui/material';
import {
  useEffect,
  useRef
} from 'react';
import * as ds from './dataService';


export type ChatInputFieldProps = {
  listedCompanyId: string;
  disabled?: boolean;
  handleSubmit: (value: string) => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ChatInputFieldProps) => {
  const theme = useTheme();
  const { form } = ds.useFormState();
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const func = function (ev: KeyboardEvent) {
      if (ev.ctrlKey && (ev.key === 'a' || ev.key === 'A')) {
        ref.current?.focus();
      }
    };
    document.addEventListener('keypress', func);
    return () => {
      document.removeEventListener('keypress', func);
    };
  }, []);

  return (
    <Box
      padding='1rem'
    >

      <Box
        display='flex'
        borderRadius='.5rem'
        paddingX='.75rem'
        height='2.5rem'
        bgcolor={theme.palette.primary.darker140}
        justifyContent='space-between'
        alignItems='center'
      >
        <Box
          flex='1 1 0'
          component='form'
          onSubmit={async (e) => {
            e.preventDefault();
            props.handleSubmit(form.formState.userInput);
            form.dispatch({
              type: 'RESET'
            });
          }}

          onKeyDown={async (e) => {
            if (e.metaKey && e.key === 'Enter') {
              props.handleSubmit(form.formState.userInput);
              form.dispatch({
                type: 'RESET'
              });
            }
          }}
        >
          <FormControl
            fullWidth
          >
            <InputBase
              inputRef={ref}
              // disabled={props.disabled}
              endAdornment={(
                <Button
                  type='submit'
                  sx={{
                    ...theme.typography.chartTitle,
                    color: theme.palette.gray.light20,
                    marginX: 0,
                    paddingX: 0
                  }}
                >
                  <Typography
                    marginLeft='.5rem'
                    marginRight='0rem'
                  >
                    Ctrl + A
                  </Typography>
                </Button>

              )}
              // placeholder='Type question to choose a pre-populated prompt...'
              placeholder='Ask a question or pick a question from above.'
              sx={{
                fontSize: 14,
                color: theme.palette.primary.light05,
                webkitTextFillColor: `${theme.palette.primary.light05} !important`,
                fontFamily: 'Roboto',
                textWrap: 'wrap'
              }}

              fullWidth
              // {...form.genFieldProps('userInput')}
              {...form.genFieldProps('userInput')}
            />
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
};
